import type { TranslationModule } from '../types';

export const trackCasesSectionTranslations: TranslationModule = {
  ro: {
    badge: "FUNCȚIE PRO",
    title: "Urmărire Dosare & Notificări Alerte",
    subtitle: "Monitorizează automat dosarele în instanță direct din portalul național. Primești alerte instant prin email la fiecare modificare de termen sau hotărâre.",
    checklist: [
      "Notificări automate pentru termene, ședințe și hotărâri judecătorești",
      "Urmărești dosarele fără să intri zilnic pe portalul instanțelor",
      "Salvezi dosarul pentru urmărire cu un singur click din fișa completă",
      "Căutare rapidă după număr unic de dosar sau numele unei părți",
      "Acces facil direct de pe telefon, tabletă sau calculator"
    ],
    btnCTA_auth: "Vizualizează dosarele urmărite",
    btnCTA_guest: "Vezi abonamentele Pro",
    btnMore: "Autentificare rapidă",
    cards: {
      sync: {
        title: "Cum funcționează urmărirea?",
        desc: "<strong>1. Cauți dosarul</strong> după număr sau nume parte. <br /><strong>2. Îl salvezi</strong> pentru urmărire din fișa sa de detalii. <br /><strong>3. Primești notificări</strong> instant în secunda în care apar actualizări în portal."
      },
      portal: {
        title: "Detalii complete din Portal",
        desc: "Afișăm într-un singur loc detalii complete despre: data înregistrării, instanța/secția, categoria și stadiul procesual, lista părților implicate, termene/ședințe, căi de atac și data ultimei modificări."
      },
      search: {
        title: "Căutare după număr de dosar",
        desc: "Introdu numărul de dosar în formatul standard. Suportăm căutare inteligentă inclusiv pentru wildcard-uri sau subdosare (ex: <code>123/123/2024</code> sau <code>123/123/2024/a1</code>) pe multiple instanțe simultan."
      },
      party: {
        title: "Căutare după numele unei părți",
        desc: "Alegi instanța dorită (ex: Tribunalul București) și introduci numele complet. Pentru rezultate corecte și precise, recomandăm să folosești numele și prenumele integral al persoanei sau firmei."
      },
      alerts: {
        title: "Alerte pe Email — Pro",
        desc: "Monitorizarea automată și alertele pe email sunt disponibile utilizatorilor Pro. Primești notificări la fiecare actualizare relevantă de termen sau soluție în dosarele urmărite."
      }
    },
    benefits_title: "Avantaje LegeaAplicată",
    benefits: [
      "Alerte automate în timp real la 8:00 AM",
      "Link-uri directe spre detalii pe site-ul nostru",
      "Secțiunea privată „Dosare urmărite”"
    ],
    security: "Securizat & Privat"
  },
  en: {
    badge: "PRO FEATURE",
    title: "Case Tracking & Alert Notifications",
    subtitle: "Automatically monitor court cases directly from the national portal. Receive instant email alerts for every hearing or ruling change.",
    checklist: [
      "Automatic notifications for hearings, sessions, and court rulings",
      "Track cases without checking the court portal daily",
      "Save the case for tracking with a single click from the details sheet",
      "Quick search by unique case number or party name",
      "Easy access directly from phone, tablet, or computer"
    ],
    btnCTA_auth: "View followed cases",
    btnCTA_guest: "View Pro plans",
    btnMore: "Quick login",
    cards: {
      sync: {
        title: "How does tracking work?",
        desc: "<strong>1. Search the case</strong> by number or party name. <br /><strong>2. Save it</strong> for tracking from its details sheet. <br /><strong>3. Receive instant notifications</strong> as soon as updates appear in the portal."
      },
      portal: {
        title: "Full details from Portal",
        desc: "We display in one place full details about: registration date, court/department, case category and procedural stage, list of involved parties, hearings/sessions, appeals, and last modification date."
      },
      search: {
        title: "Search by case number",
        desc: "Enter the case number in the standard format. We support smart search including wildcards or sub-files (e.g. <code>123/123/2024</code> or <code>123/123/2024/a1</code>) across multiple courts simultaneously."
      },
      party: {
        title: "Search by party name",
        desc: "Choose the desired court (e.g. Bucharest Tribunal) and enter the full name. For correct and precise results, we recommend using the full first and last name of the person or company."
      },
      alerts: {
        title: "Email Alerts — Pro",
        desc: "Automatic monitoring and email alerts are available to Pro users. Receive notifications for every relevant hearing or ruling update in followed cases."
      }
    },
    benefits_title: "LegeaAplicată Advantages",
    benefits: [
      "Automatic real-time alerts at 8:00 AM",
      "Direct links to details on our website",
      "Private 'Followed Cases' section"
    ],
    security: "Secure & Private"
  },
  fr: {
    badge: "FONCTION PRO",
    title: "Suivi des Dossiers & Alertes de Notification",
    subtitle: "Suivez automatiquement les dossiers judiciaires directement depuis le portail national. Recevez des alertes e-mail instantanées pour chaque changement d'audience ou de décision.",
    checklist: [
      "Notifications automatiques pour les audiences, sessions et décisions de justice",
      "Suivez les dossiers sans consulter quotidiennement le portail des tribunaux",
      "Enregistrez le dossier pour le suivi d'un simple clic depuis la fiche complète",
      "Recherche rapide par numéro de dossier unique ou nom de partie",
      "Accès facile directement depuis un téléphone, une tablette ou un ordinateur"
    ],
    btnCTA_auth: "Voir les dossiers suivis",
    btnCTA_guest: "Voir les abonnements Pro",
    btnMore: "Connexion rapide",
    cards: {
      sync: {
        title: "Comment fonctionne le suivi ?",
        desc: "<strong>1. Recherchez le dossier</strong> par numéro ou nom de partie. <br /><strong>2. Enregistrez-le</strong> pour le suivi depuis sa fiche de détails. <br /><strong>3. Recevez des notifications instantanées</strong> dès que des mises à jour apparaissent sur le portail."
      },
      portal: {
        title: "Détails complets du Portail",
        desc: "Nous affichons en un seul endroit tous les détails : date d'enregistrement, tribunal/département, catégorie et phase de procédure, liste des parties, audiences/sessions, recours et date de dernière modification."
      },
      search: {
        title: "Recherche par numéro de dossier",
        desc: "Saisissez le numéro de dossier au format standard. Nous prenons en charge la recherche intelligente, y compris les caractères génériques ou sous-dossiers (ex : <code>123/123/2024</code> ou <code>123/123/2024/a1</code>) sur plusieurs tribunaux simultanément."
      },
      party: {
        title: "Recherche par nom de partie",
        desc: "Choisissez le tribunal souhaité (ex : Tribunal de Bucarest) et saisissez le nom complet. Pour des résultats corrects et précis, nous vous recommandons d'utiliser le nom et prénom complets de la personne ou de l'entreprise."
      },
      alerts: {
        title: "Alertes e-mail — Pro",
        desc: "Le suivi automatisé et les alertes par e-mail sont réservés aux utilisateurs Pro. Recevez des notifications pour chaque mise à jour d'audience ou de décision dans vos dossiers suivis."
      }
    },
    benefits_title: "Avantages LegeaAplicată",
    benefits: [
      "Alertes automatiques en temps réel à 8h00",
      "Liens directs vers les détails sur notre site",
      "Section privée 'Dossiers suivis'"
    ],
    security: "Sécurisé & Privé"
  }
};

export default trackCasesSectionTranslations;
